export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Číslo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jméno"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Akce"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upravit informace o kolektoru"])}
}